import { Injectable } from '@angular/core';
import { IndividualConfig, ToastService } from 'ng-uikit-pro-standard';

@Injectable({
  providedIn: 'root'
})
export class MessageRendererService {

  constructor(private toastrService: ToastService) { }

  showErrors(mensajes, overrides: IndividualConfig = null) {
    mensajes.filter(m => m.tipo === "ERROR").forEach(mensaje => {
      if (overrides)
        this.toastrService.error(mensaje.texto, null, overrides)
      else
        this.toastrService.error(mensaje.texto)
    });
  }

  showInfoMessages(mensajes, overrides: IndividualConfig = null) {
    mensajes.filter(m => m.tipo === "INFO").forEach(mensaje => {
      if (overrides)
        this.toastrService.info(mensaje.texto, null, overrides)
      else
        this.toastrService.info(mensaje.texto)
    });
  }

  showWarningMessages(mensajes, overrides: IndividualConfig = null) {
    mensajes.filter(m => m.tipo === "WARNING").forEach(mensaje => {
      if (overrides)
        this.toastrService.warning(mensaje.texto, null, overrides)
      else
        this.toastrService.warning(mensaje.texto)
    });
  }
}
